import { Avatar } from "@mui/material";
import { IMAGE_URL } from "config";
import { memo } from "react";

const StructureAvatar = memo(({ imageUrl, name }) => (
  <Avatar
    src={imageUrl ? `${IMAGE_URL}/${imageUrl}` : undefined}
    alt={name}
    sx={{ width: 40, height: 40 }}
  >
    {!imageUrl && name?.charAt(0)?.toUpperCase()}
  </Avatar>
));

StructureAvatar.displayName = "StructureAvatar";

export default StructureAvatar;
